import { useTranslation } from '@wix/wix-i18n-config';
import React, { FC, useCallback, useMemo } from 'react';

import { TLocalesKeys } from '../../../../types';
import { IUserAccountItem, IUserAccountsSelector } from '../../../common/messageCreators';
import { useUserActionClickSelector } from '../../hooks';
import { MessageItem } from '../MessageItem';
import { SelectorFooter, SelectorItem, SelectorWrapper } from '../Selectors';
import { UserAccountItem } from './UserAccountItem';

export const UserAccountsSelector: FC<IUserAccountsSelector> = ({ id, type, items }) => {
  const emit = useUserActionClickSelector();
  const { t } = useTranslation();

  const onClick = useCallback(
    (item: IUserAccountItem, position: number) => {
      emit(type, {
        position,
        label: item.accountName,
        item,
      });
    },
    [emit, type],
  );

  const footerLabel = t<TLocalesKeys>('do_not_see_account');

  const onClickFooter = useCallback(() => {
    emit(type, {
      label: footerLabel,
      footer: true,
    });
  }, [emit, footerLabel, type]);

  const list = useMemo(
    () =>
      items.map((item, i) => (
        <SelectorItem key={item._id} onClick={() => onClick(item, i)}>
          <UserAccountItem {...item} />
        </SelectorItem>
      )),
    [items, onClick],
  );

  return (
    <MessageItem id={id}>
      <SelectorWrapper>
        {list}
        <SelectorFooter label={footerLabel} onClick={onClickFooter} />
      </SelectorWrapper>
    </MessageItem>
  );
};
